<template>
  <div
    class="d-flex-row height-max-content space-between align-md-start position_link b-radius-16"
  >
    <div
      class="d-flex-row justify-start flex-9 gap-32 gap-md-16 md-row-to-col align-md-start"
    >
      <img :src="gameIcon" class="game_icon" />
      <div class="d-flex-column justify-start align-start gap-5">
        <h6 class="t-white font-family-1 title-h6 f-w-600">{{ title }}</h6>
        <div class="d-flex-row justify-start height-max-content gap-12">
          <!-- GAME NAME -->
          <label class="t-orange font-family-2 medium-xl">{{
            gameTitle
          }}</label>
          <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="servers"
          >
            <circle cx="4" cy="4" r="4" fill="#45494D" />
          </svg>
          <!-- SERVER -->
          <label class="t-orange font-family-2 medium-xl">{{ servers }}</label>
        </div>
        <p class="t-grey font-family-2 regular-xl">
          {{ shortDescription }}
        </p>
      </div>
    </div>

    <NuxtLinkLocale
      :to="`/work-with-us/${slug}`"
      class="primary filled xxl b-radius-9 regular-l t-black f-w-600 font-family-1 white-space-no apply_btn"
      style="line-height: normal; font-style: normal;"
    >
      {{ $t("work_with_us.apply_now") }}
    </NuxtLinkLocale>
  </div>
</template>

<script setup>
const props = defineProps({
  title: {
    default: "",
  },
  game: {
    default: "",
  },
  type: {
    default: "",
  },
  servers: {
    default: "",
  },
  shortDescription: {
    default: "",
  },
  gameSlug: {
    default: "",
  },
  slug: {
    default: "",
  },
});

const gameTitle = computed(() => {
  if (props.type === "for-platform") return "Boosting Market";
  return props.game;
});

const gameIcon = computed(() => {
  if (props.type === "for-platform") return "/images/bm-logo-job.webp";
  return `/images/games/${props.gameSlug}/game_icon.webp`;
});
</script>

<style lang="scss">
.position_link {
  padding: 30px 32px;
  border-radius: 16px;
  border-top: 1px solid #191c1f;
  border-bottom: 1px solid #191c1f;
  background: var(--bg-dark, #0e1012);

  .game_icon {
    width: 80px;
    height: 80px;
    object-fit: cover;
    object-position: center;
  }

  @media screen and (max-width: 768px) {
    .game_icon {
      width: 56px;
      height: 56px;
    }
    gap: 16px;
    flex-direction: column;
  }
}
</style>
